import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    OxfordBlue: {
      bg: "#344052",
      font: "#FFFFFF"
    },
    PeriwinkleGray: {
      bg: "#BDD0E4",
      font: "#000080"
    },
    Viking: {
      bg: "#73BBD6",
      font: "#191970"
    },
    SteelBlue: {
      bg: "#5F86BB",
      font: "#FFFFFF"
    }
  }
});

export default theme;
